import React from 'react';

const Cookies = () => (
  <main className="max-w-3xl mx-auto px-4 py-20 text-gray-800 dark:text-gray-200">
    <h1 className="text-3xl sm:text-4xl font-bold mb-6">Politica de Cookies</h1>
    <p className="mb-4">Folosim cookie-uri pentru a asigura funcționarea site-ului și pentru a îmbunătăți experiența utilizatorilor.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">1. Ce sunt cookie-urile</h2>
    <p className="mb-4">Fișiere text mici stocate pe dispozitivul tău atunci când vizitezi un site. Ele ajută la reținerea preferințelor și la funcționarea corectă a paginilor.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">2. Tipuri de cookie-uri</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>esențiale: necesare pentru funcționare (autentificare, salvarea preferințelor);</li>
      <li>de performanță: statistici anonime despre utilizare;</li>
      <li>marketing (opționale): utilizate doar cu consimțământ.</li>
    </ul>

    <h2 className="text-xl font-semibold mt-6 mb-2">3. Cum poți controla cookie-urile</h2>
    <p className="mb-4">Poți modifica setările din browser pentru a bloca sau șterge cookie-urile. Reține că blocarea cookie-urilor esențiale poate afecta funcționarea site-ului.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">4. Contact</h2>
    <p className="mb-4">Întrebări? Scrie-ne la <a href="mailto:catadorca@yahoo.com" className="text-primary underline">catadorca@yahoo.com</a>.</p>
  </main>
);

export default Cookies; 